/* Bull Ring Fabrics — magic bag hint (2026-10-26, Abid).
   Desktop only (mouse and screen 1000px+). After something is added to the bag, and once the "In the bag!"
   note or the bag drawer has gone, a small glass bubble points at the bag: hovering it opens the bag, no click needed.
   Shown at most once a page and 3 times in all, and never again once the customer has opened the bag by hovering.
   If they hover the bag while the bubble is showing, the bubble steps aside so the bag can open. */
(function () {
  if (window.__brfBagHint) return; window.__brfBagHint = 1;
  var doc = document, root = doc.documentElement;
  if (!window.matchMedia) return;
  var mq = matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function put(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function learned() { return get('brfBagHintOk') === '1'; }
  function shownN() { return parseInt(get('brfBagHintN') || '0', 10) || 0; }
  function onCart() { return (window.theme && theme.pageType === 'cart') || (doc.body && doc.body.classList.contains('template-cart')); }

  var LINES = [
    ['Psst… your bag is magic', 'No need to click. Just hover over it and it opens all by itself.'],
    ['A little bit of magic', 'Glide your mouse over the bag to peek inside, no clicking needed.'],
    ['Your bag has a secret', 'Hover over it and it opens like magic, so you can keep on shopping.']
  ];
  var NOTE = 'We’ve sprinkled little bits of magic like this all over Bullring to make shopping easier.';

  var css = '' +
    '.brf-bh{position:fixed;z-index:2147483003;width:300px;padding:14px 16px 14px 14px;border-radius:22px;' +
    'background:rgba(255,255,255,.94);-webkit-backdrop-filter:saturate(1.8) blur(24px);backdrop-filter:saturate(1.8) blur(24px);' +
    'box-shadow:0 0 0 .5px rgba(29,29,31,.08),0 24px 60px -22px rgba(29,29,31,.45);color:#1D1D1F;' +
    'font:15px/1.35 -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,"Helvetica Neue",Helvetica,Arial,sans-serif;' +
    'display:flex;gap:12px;align-items:flex-start;opacity:0;transform:translateY(-8px) scale(.96);transform-origin:var(--brf-bh-x,85%) 0;' +
    'transition:opacity .35s ease,transform .45s cubic-bezier(.2,.9,.25,1.25);pointer-events:none}' +
    '.brf-bh.is-on{opacity:1;transform:none;pointer-events:auto}' +
    '.brf-bh::before{content:"";position:absolute;inset:0;border-radius:inherit;padding:1.5px;pointer-events:none;' +
    'background:linear-gradient(120deg,#149954,#E0A526,#C9A06A,#149954);background-size:300% 100%;animation:brfBhSheen 4s linear infinite;' +
    '-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude}' +
    '.brf-bh__tip{position:absolute;top:-7px;left:var(--brf-bh-x,85%);width:14px;height:14px;margin-left:-7px;background:rgba(255,255,255,.97);' +
    'transform:rotate(45deg);border-radius:3px 0 0 0;box-shadow:-1px -1px 0 0 rgba(224,165,38,.55)}' +
    '.brf-bh__ic{flex:0 0 38px;height:38px;border-radius:50%;display:grid;place-items:center;' +
    'background:radial-gradient(circle at 30% 30%,#fff7df,#f3dca0 55%,#E0A526);box-shadow:inset 0 0 0 .5px rgba(0,0,0,.06)}' +
    '.brf-bh__ic svg{width:22px;height:22px;animation:brfBhWand 2.4s ease-in-out infinite;transform-origin:30% 80%}' +
    '.brf-bh__tx{flex:1;min-width:0}' +
    '.brf-bh__h{display:block;font-weight:600;font-size:15px;letter-spacing:-.01em;margin:0 0 2px}' +
    '.brf-bh__h i{font-style:normal;display:inline-block;animation:brfBhTwinkle 1.6s ease-in-out infinite}' +
    '.brf-bh__t{display:block;font-size:13.5px;color:#3a3a3c}' +
    '.brf-bh__n{display:block;font-size:12px;color:#6e6e73;margin-top:6px}' +
    '.brf-bh__x{all:unset;cursor:pointer;margin-top:8px;display:inline-block;font-size:12.5px;font-weight:600;color:#149954;' +
    'padding:4px 10px;border-radius:999px;background:rgba(20,153,84,.1)}' +
    '.brf-bh__x:hover{background:rgba(20,153,84,.18)}.brf-bh__x:focus-visible{outline:2px solid #149954;outline-offset:2px}' +
    '.brf-bh__dust{position:absolute;width:6px;height:6px;border-radius:50%;background:#E0A526;pointer-events:none;opacity:0;' +
    'box-shadow:0 0 8px 2px rgba(224,165,38,.6);animation:brfBhDust 2.2s ease-out infinite}' +
    '.brf-bh-glow{border-radius:999px;animation:brfBhGlow 1.8s ease-in-out infinite}' +
    '@keyframes brfBhSheen{to{background-position:300% 0}}' +
    '@keyframes brfBhWand{0%,100%{transform:rotate(-8deg)}50%{transform:rotate(10deg)}}' +
    '@keyframes brfBhTwinkle{0%,100%{transform:scale(1) rotate(0);opacity:1}50%{transform:scale(1.25) rotate(15deg);opacity:.7}}' +
    '@keyframes brfBhDust{0%{opacity:0;transform:translate(0,0) scale(.4)}20%{opacity:1}100%{opacity:0;transform:translate(var(--dx),var(--dy)) scale(.2)}}' +
    '@keyframes brfBhGlow{0%,100%{box-shadow:0 0 0 0 rgba(224,165,38,0)}50%{box-shadow:0 0 0 6px rgba(224,165,38,.28),0 0 22px 4px rgba(224,165,38,.35)}}' +
    '@media (prefers-reduced-motion: reduce){.brf-bh,.brf-bh.is-on{transition:opacity .2s}.brf-bh::before,.brf-bh__ic svg,.brf-bh__h i,.brf-bh__dust,.brf-bh-glow{animation:none}}';

  var box = null, timer = 0, waitT = 0, anchor = null, raf = 0, armed = false, onPage = false, tries = 0;

  function bag() {
    var list = [];
    if (root.classList.contains('brf-hc')) list.push(doc.querySelector('[data-brf-hc-cart]'));
    var hdr = doc.getElementById('shopify-section-header');
    list.push(hdr && (hdr.querySelector('.header__cart-toggle') || hdr.querySelector('a[href$="/cart"]')));
    list.push(doc.querySelector('[data-brf-hc-cart]'));
    for (var i = 0; i < list.length; i++) {
      var el = list[i]; if (!el) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.top >= 0 && r.bottom <= innerHeight && getComputedStyle(el).visibility !== 'hidden') return el;
    }
    return null;
  }
  function busy() {
    var t = doc.querySelector('.brf-hc__toast.is-on'), p = doc.querySelector('.brf-hc__bag.is-open'),
      mc = doc.querySelector('#mini-cart[aria-hidden="false"]'), m = doc.querySelector('.modal[aria-hidden="false"]');
    return !!(t || p || mc || m || root.classList.contains('is-locked'));
  }
  function build() {
    if (box) return box;
    var st = doc.createElement('style'); st.textContent = css; doc.head.appendChild(st);
    box = doc.createElement('div'); box.className = 'brf-bh'; box.setAttribute('role', 'status'); box.setAttribute('aria-live', 'polite');
    doc.body.appendChild(box);
    box.addEventListener('mouseenter', function () { clearTimeout(timer); });
    box.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(hide, 3000); });
    return box;
  }
  function wand() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M4 20 14.5 9.5"/><path d="m13 8 3 3"/>' +
      '<path d="M18 2.5v3M16.5 4h3" stroke="#B3261E"/><path d="M20.5 9v2M19.5 10h2" stroke="#149954"/><path d="M9 3v2M8 4h2" stroke="#149954"/></svg>';
  }
  function place() {
    if (!box || !anchor) return;
    /* the full header's bag has its "Bag" label underneath, so sit below the whole item */
    var r = (anchor.closest('.header__action-item') || anchor).getBoundingClientRect();
    if (r.width === 0 || r.bottom < 0 || r.top > innerHeight) { hide(); return; }
    var w = box.offsetWidth || 300, cx = r.left + r.width / 2;
    var left = Math.max(12, Math.min(innerWidth - w - 12, cx - w * 0.82));
    box.style.left = left + 'px'; box.style.top = (r.bottom + 14) + 'px';
    box.style.setProperty('--brf-bh-x', Math.max(18, Math.min(w - 18, cx - left)) + 'px');
  }
  function onMove() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; place(); }); }
  function dust() {
    if (calm) return '';
    var s = '', pts = [[-26, -20, 0], [24, -26, .5], [-30, 18, 1], [30, 14, 1.4], [0, -34, 1.8]];
    for (var i = 0; i < pts.length; i++) s += '<span class="brf-bh__dust" style="left:' + (i % 2 ? 26 : 14) + 'px;top:' + (i % 2 ? 30 : 20) + 'px;--dx:' + pts[i][0] + 'px;--dy:' + pts[i][1] + 'px;animation-delay:' + pts[i][2] + 's"></span>';
    return s;
  }
  function show() {
    if (onPage || learned() || shownN() >= 3 || !mq.matches || onCart()) return;
    if (busy()) { if (++tries < 40) { clearTimeout(waitT); waitT = setTimeout(show, 500); } return; }
    anchor = bag(); if (!anchor) return;
    onPage = true; put('brfBagHintN', String(shownN() + 1));
    var l = LINES[Math.floor(Math.random() * LINES.length)];
    build().innerHTML = '<span class="brf-bh__tip" aria-hidden="true"></span>' + dust() +
      '<span class="brf-bh__ic">' + wand() + '</span>' +
      '<span class="brf-bh__tx"><span class="brf-bh__h">' + l[0] + ' <i aria-hidden="true">✨</i></span>' +
      '<span class="brf-bh__t">' + l[1] + '</span><span class="brf-bh__n">' + NOTE + '</span>' +
      '<button type="button" class="brf-bh__x">Ooh, got it</button></span>';
    box.querySelector('.brf-bh__x').addEventListener('click', function () { put('brfBagHintOk', '1'); hide(); });
    place(); void box.offsetWidth; box.classList.add('is-on');
    anchor.classList.add('brf-bh-glow');
    anchor.addEventListener('mouseenter', magic);
    addEventListener('scroll', onMove, {passive: true}); addEventListener('resize', onMove);
    clearTimeout(timer); timer = setTimeout(hide, 9000);
  }
  function magic() {
    /* the bag peek opening is the magic itself, so the bubble steps aside straight away */
    put('brfBagHintOk', '1'); hide();
  }
  function hide() {
    clearTimeout(timer);
    if (anchor) { anchor.classList.remove('brf-bh-glow'); anchor.removeEventListener('mouseenter', magic); }
    removeEventListener('scroll', onMove); removeEventListener('resize', onMove);
    if (box) box.classList.remove('is-on');
  }
  function added() {
    if (armed || onPage || learned() || shownN() >= 3 || !mq.matches || onCart()) return;
    armed = true; tries = 0;
    /* let the "In the bag!" note (or the bag drawer) appear first, then wait for it to go */
    clearTimeout(waitT); waitT = setTimeout(function () { armed = false; show(); }, 1200);
  }

  /* hovering the bag opens its peek: once that has happened the customer knows the trick */
  function watchPeek() {
    var p = doc.querySelector('.brf-hc__bag'); if (!p || p.__brfBh || !window.MutationObserver) return;
    p.__brfBh = 1;
    new MutationObserver(function () { if (p.classList.contains('is-open') && !onPage) put('brfBagHintOk', '1'); }).observe(p, {attributes: true, attributeFilter: ['class']});
  }
  /* adds: the theme's event, plus the header count going up (covers every add button) */
  doc.addEventListener('product:added', added, true);
  doc.addEventListener('brf:bag-added', added, true);
  var last = -1;
  function watchCount() {
    var c = doc.querySelector('#shopify-section-header .header__cart-count');
    if (!c || c.__brfBh || !window.MutationObserver) return; c.__brfBh = 1;
    last = parseInt(c.textContent, 10) || 0;
    new MutationObserver(function () { var n = parseInt(c.textContent, 10) || 0; if (n > last) added(); last = n; }).observe(c, {childList: true, characterData: true, subtree: true});
  }
  function boot() { watchPeek(); watchCount(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(boot, 2000);
  /* for testing: window.brfBagHint() shows it now */
  window.brfBagHint = function () { onPage = false; try { localStorage.removeItem('brfBagHintOk'); localStorage.removeItem('brfBagHintN'); } catch (e) {} tries = 0; show(); };
})();
